<template>

    <div class="mainApp" data-font-size="10" data-font-size-type="px">
        <div class="overlay" data-font-size="10" data-font-size-type="px"></div>
        <div data-font-size="10" data-font-size-type="px">
           <div class="hp rteContainer" data-font-size="10" data-font-size-type="px">
              <div class="rteBox" data-font-size="10" data-font-size-type="px">
                 <h1 class="mainTitle" data-font-size="35" data-font-size-type="px">הצהרת נגישות</h1>
                 <div class="rteBoxInner" data-font-size="10" data-font-size-type="px">
                    <section class="rte">
                       <div class="umb-grid" data-font-size="10" data-font-size-type="px">
                          <div class="grid-section" data-font-size="10" data-font-size-type="px">
                             <div>
                                <div class="row clearfix">
                                   <div class="col-md-4 column">
                                      <div><img src="/images/trendsimg.png" alt=""></div>
                                   </div>
                                   <div class="col-md-8 column">
                                      <div>
                                         <h4>אתר זה הוקם ומנוהל על ידי יחידת "ממשל זמין" של רשות התקשוב הממשלתי במשרד ראש הממשלה. אנו רואים חשיבות רבה במתן שירות שוויוני לכלל האזרחים.</h4>
                                         <p>אתר זה הוקם ומנוהל על ידי יחידת "ממשל זמין" של רשות התקשוב הממשלתי במשרד ראש הממשלה. אנו רואים חשיבות רבה במתן שירות שוויוני לכלל האזרחים ובשיפור השירות הניתן לאזרחים עם מוגבלות. לשם כך הושקעו משאבים רבים בהנגשת האתר, במטרה להקל את השימוש בו ולהפוך את שירותי הממשלה לזמינים יותר עבור אנשים עם מוגבלות.<br>על פי נתוני עמותת "נגישות ישראל", כ-20 אחוזים מקרב האוכלוסייה בישראל הינם אנשים בעלי מוגבלות הזקוקים לנגישות דיגיטלית, על מנת לצרוך מידע ושירותי ממשלה באינטרנט.<br>הנגשת האתר נועדה אפוא לשפרו כך שיהיה זמין, ידידותי ונוח יותר לשימוש עבור אוכלוסיות עם צרכים מיוחדים, הנובעים בין היתר ממוגבלויות מוטוריות שונות, לקויות קוגניטיביות, קוצר רואי, עיוורון או עיוורון צבעים, לקויות שמיעה וכן אוכלוסייה הנמנית על בני הגיל השלישי.<br>בהתאם לנדרש בתקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות) תשע"ג-2013 (להלן: "התקנות"), האתר עומד בתקן הנגישות בדרגה AA. בהתאם לקריטריונים המפורטים בהנחיות Accessibility Guidelines Web Content של גוף התקינה הבין-לאומי World Wide Web Consortium (W3C) הנגישות לאינטרנט:</p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                             <div>
                                <div class="row clearfix">
                                   <div class="col-md-12 column">
                                      <div>
                                         <h4>רמת הנגישות באתר</h4>
                                         <ul>
                                            <li>אמצעי הניווט באתר פשוטים וברורים</li>
                                            <li>תכני האתר כתובים באופן ברור, מסודר והיררכי. במידת הצורך קיימים הסברים לצד התוכן</li>
                                            <li>האתר מותאם לצפייה בדפדפנים מודרניים</li>
                                            <li>התאמת האתר לתצוגה תואמת מגוון מסכים ורזולוציות</li>
                                            <li>תוכן האתר כתוב בשפה פשוטה וברורה</li>
                                            <li>כל הדפים באתר בעלי מבנה קבוע</li>
                                            <li>לכל התמונות באתר יש הסבר טקסטואלי חלופי (alt)</li>
                                            <li>האתר מאפשר שינוי גודל הגופן על ידי שימוש במקש Ctrl וגלגלת העכבר</li>
                                            <li>אין באתר שימוש בתצוגת טקסט נע או מהבהב</li>
                                         </ul>
                                         <p>חשוב לציין, כי למרות מאמצינו להנגיש את כלל הדפים באתר, ייתכן שיתגלו חלקים או יכולות באתר שלא הונגשו כראוי או שטרם הונגשו.<br>לידיעתכם, לשירות הטפסים ולרכיב הזדהות של הכרטיס החכם, קיים פטור נגישות מטעמים טכנולוגיים החתום על ידי מומחה מתחום האינטרנט ומורשה לנגישות השירות.<br>אנו פועלים לשפר את נגישות האתר כחלק ממחויבותנו לאפשר בו שימוש עבור כלל האוכלוסייה, כולל אנשים עם מוגבלות.</p>
                                         <p>&nbsp;</p>
                                         <h4>יצירת קשר בנושא נגישות</h4>
                                         <p>אם במהלך הגלישה באתר נתקלתם בבעיה בנושא נגישות, נשמח לקבל הערות ובקשות, באמצעות פנייה לאחראי הנגישות באתר בדואר האלקטרוני</p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </div>
                    </section>
                 </div>
              </div>
           </div>
           <div class="hpSearchSection rteSection" data-font-size="10" data-font-size-type="px"></div>
        </div>
     </div>
  
   
</template>
   
   
   
<script>

export default {
    name: 'AccebeilityView',
    data() {
        return {
            //
        }
    },
    methods: {
        //
    },
    mounted() {
        //
    }
}
</script>